import React from 'react';
import styled from 'styled-components';
import brandIcon from '../../assets/brandIcon.png';
import youtube from '../../assets/youtube.svg';
import twitter from '../../assets/twitter.svg';
import instagram from '../../assets/instagram.svg';
import facebook from '../../assets/facebook.svg';
import map from '../../assets/map.png';
import liststyletype from '../../assets/liststyletype.svg';
import { Link } from 'react-router-dom';

export default function Footer() {
 return (
  <FooterDiv id='contact'>
   <Wrapper>
    <Aboutdiv>
     <Imagediv>
      <Image src={brandIcon} alt={'zigma epr brand icon'} />
     </Imagediv>
     <Content>
      <p>
       Track, trace and fulfil your EPR targets by partnering with the largest
       landfill mining company in India
      </p>
      <Iconsdiv>
       <Icon>
        <a>
         <img src={youtube} alt='youtube icon' />
        </a>
       </Icon>
       <Icon>
        <a href='https://www.linkedin.com/company/zigma-global-environ-solutions-plc/'>
         <img src={twitter} alt='twitter icon' />
        </a>
       </Icon>
       <Icon>
        <a>
         <img src={instagram} alt='instagram icon' />
        </a>
       </Icon>
       <Icon>
        <a href='https://m.facebook.com/zigmaglobal/'>
         <img src={facebook} alt='facebook icon' />
        </a>
       </Icon>
      </Iconsdiv>
      <Support>
       <img src={map} alt='map showing location of zigma' />
       <div>
        <p>+91 82200 07605</p>
        <p>eprconnect@zigma.in</p>
        <p>zigma.in</p>
       </div>
      </Support>
     </Content>
     <Links>
      <p>privacy policy</p>
      <p>terms and conditions</p>
     </Links>
    </Aboutdiv>
    <Quicklinks liststyletype={liststyletype}>
     <div className='header'>
      Quick <span>Link</span>
     </div>
     <div className='links'>
      <div>
       <img src={liststyletype} alt='list bullet' />
       <Link to={'/'}>Home</Link>
      </div>
      <div>
       <img src={liststyletype} alt='list bullet' />
       <a href='https://zigma-dashboard.netlify.app/'>Login</a>
      </div>
      <div>
       <img src={liststyletype} alt='list bullet' />
       <Link to='#'> EPR Solution</Link>
      </div>
      <div>
       <img src={liststyletype} alt='list bullet' />
       <Link to='/#aboutdiv'>About Zigma</Link>
      </div>
     </div>
    </Quicklinks>
    <Contactdiv>
     <div className='header'>
      Contact <span>Us</span>
     </div>
     <div className='content'>
      <p>
       For more information fill the details. Our team will get back to you in
       24 hours.
      </p>
      <form action='/'>
       <div>
        <label htmlFor='email'>Mail Id</label>
        <input type='email' name='email' id='email' />
       </div>
       <div>
        <label htmlFor='message'>Your Message</label>
        <textarea type='text' name='message' id='message' />
       </div>
       <div className='button'>Contact</div>
      </form>
     </div>
    </Contactdiv>
   </Wrapper>
  </FooterDiv>
 );
}

const FooterDiv = styled.div`
 background: #ededed;
`;

const Wrapper = styled.div`
 width: 90%;
 margin: 0 auto;
 display: flex;
 gap: 4rem;
 padding: 4rem;
 @media screen and (max-width: 600px) {
  flex-direction: column;
 }
`;

const Aboutdiv = styled.div`
 width: 40%;
 display: flex;
 justify-content: start;
 flex-direction: column;
 @media screen and (max-width: 600px) {
  width: 100%;
 }
`;

const Imagediv = styled.div`
 width: fit-content;
 margin-bottom: 2rem;
`;

const Image = styled.img`
 height: 4rem;
 width: auto;
 object-fit: contain;
`;
const Content = styled.div`
 padding-left: 5rem;
 color: #6b6b6b;
 font-size: 1rem;
 font-weight: 600;
 text-align: justify;
 display: flex;
 flex-direction: column;
 gap: 2rem;
 margin-bottom: 3rem;
`;

const Iconsdiv = styled.div`
 display: flex;
 gap: 1rem;
 cursor: pointer;
`;
const Icon = styled.div`
 border-radius: 50%;
 background-color: #90d62b;
 color: #fff;
 padding: 0.75rem;
 img {
  width: 1.5rem;
  height: 1.5rem;
 }
`;

const Support = styled.div`
 display: flex;
 gap: 1rem;
 img {
  width: 6rem;
  height: 6rem;
  object-fit: cover;
 }
 p {
  color: #414141;
  font-size: 1rem;
  font-weight: 400;
  margin: 0;
 }
`;

const Links = styled.div`
 text-align: left;
 p {
  display: inline;
  margin-right: 2rem;
  text-transform: capitalize;
  color: #90d62b;
  letter-spacing: 0.05rem;
  font-size: 1.2rem;
  cursor: pointer;
 }
`;

const Quicklinks = styled.div`
 width: 20%;
 text-align: left;
 .links {
  a {
   color: inherit;
  }
 }
 @media screen and (max-width: 600px) {
  width: 100%;
  .links {
   display: flex;
   flex-wrap: wrap;
   gap: 2rem;
  }
 }
 .header {
  width: fit-content;
  color: #0e0e0e;
  letter-spacing: 0.05rem;
  font-weight: 700;
  font-size: 2.5rem;
  position: relative;
  span {
   color: #90d62b;
  }
  &:after {
   content: '';
   position: absolute;
   height: 0.5rem;
   width: 20%;
   bottom: -1rem;
   left: 0;
   border-radius: 1rem;
   background-color: #90d62b;
  }
 }
 .links {
  margin-top: 3rem;
  /* margin-left: 2rem; */
  list-style-image: url(${(props) => props.liststyletype});
  div {
   display: flex;
   gap: 1rem;
   font-size: 1.4rem;
   color: #585858;
   letter-spacing: 0.025rem;
   cursor: pointer;
   margin-bottom: 1rem;
   align-items: center;
   cursor: pointer;
   img {
    height: 1rem;
    width: 1rem;
   }
  }
 }
`;
const Contactdiv = styled.div`
 width: 40%;
 text-align: left;
 @media screen and (max-width: 600px) {
  width: 100%;
 }
 .header {
  width: fit-content;
  color: #0e0e0e;
  letter-spacing: 0.05rem;
  font-weight: 700;
  font-size: 2.5rem;
  position: relative;
  span {
   color: #90d62b;
  }
  &:after {
   content: '';
   position: absolute;
   height: 0.5rem;
   width: 20%;
   bottom: -1rem;
   left: 0;
   border-radius: 1rem;
   background-color: #90d62b;
  }
 }
 .content {
  margin-top: 3rem;
  form {
   width: 70%;
  }
  p {
   /* font-family: 'Segoe UI'; */
   color: #5e5e5e;
   font-size: 1.2rem;
  }
  label {
   font-size: 1.2rem;
   line-height: 2rem;
   letter-spacing: 0.3px;
   color: #414141;
   display: block;
  }
  div {
   margin-bottom: 2rem;
  }
  input,
  textarea {
   outline: none;
   border: none;
   padding: 0.75rem;
   font-size: 1rem;
   width: 100%;
   background: linear-gradient(135deg, #ffffff 0%, #eaeaea 100%);
   box-shadow: -1px 1px 2px rgba(98, 98, 98, 0.2),
    1px -1px 2px rgba(98, 98, 98, 0.2), -1px -1px 75px rgba(255, 255, 255, 0.9),
    1px 1px 29px rgba(98, 98, 98, 0.25),
    inset 1px 1px 2px rgba(255, 255, 255, 0.3),
    inset -1px -1px 2px rgba(98, 98, 98, 0.5);
   border-radius: 0.5rem;
  }
  .button {
   background: #90d62b;
   border-radius: 1rem;
   color: #e8e8e8;
   font-size: 1.5rem;
   width: fit-content;
   padding: 0.25rem 2rem;
   margin-left: auto;
   font-weight: 600;
   cursor: pointer;
  }
 }
`;
